var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "#707070",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0.459961C3.59375 0.459961 0.5 4.80996 0.5 5.49996C0.5 6.18996 3.59375 10.54 9.5 10.54C15.4062 10.54 18.5 6.18996 18.5 5.49996C18.5 4.80996 15.4025 0.459961 9.5 0.459961ZM9.5 9.37746C7.29125 9.37746 5.49875 7.64121 5.49875 5.49996C5.49875 3.35871 7.29125 1.62246 9.5 1.62246C11.7087 1.62246 13.5012 3.35871 13.5012 5.49996C13.5012 7.64121 11.7125 9.37746 9.5 9.37746ZM9.5 5.49996C9.1325 5.09871 10.0962 3.56121 9.5 3.56121C8.39375 3.56121 7.4975 4.43121 7.4975 5.49996C7.4975 6.56871 8.39375 7.43871 9.5 7.43871C10.6062 7.43871 11.5025 6.56871 11.5025 5.49996C11.5025 5.00871 9.815 5.84121 9.5 5.49996Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwEye);
export default __webpack_public_path__ + "static/media/pwEye.8463cf68e80e1d7450a507ebcf99121a.svg";
export { ForwardRef as ReactComponent };